import React, { useEffect, useState } from "react";

import EventServices from "../../services/EventServices";
import EventCategoryServices from "../../services/EventCategoryServices";
import UserServices from "../../services/UserServices";

function EventUpdate({ user, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        // categoryId: "",
        vendorId: "",
        name: "",
        description: "",
        eventDate: "",
        startTime: "",
        endTime: "",
        venue: "",
        address: "",
        state: "",
        stateName: "",
        city: "",
        cityName: "",
        totalCapacity: "",
        status: "Active",

        termsConditions: "",

        image: null,
    });

    // =====================================================
    // DROPDOWN DATA
    // =====================================================
    const [categories, setCategories] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    const [loadingCategories, setLoadingCategories] = useState(false);
    const [loadingVendors, setLoadingVendors] = useState(false);
    const [loadingStates, setLoadingStates] = useState(false);
    const [loadingCities, setLoadingCities] = useState(false);

    const [loading, setLoading] = useState(false);

    const [previewImage, setPreviewImage] = useState(
        "img/placeholder-img.png"
    );

    // =====================================================
    // TIME FORMAT
    // API => 08:00 PM
    // INPUT TIME => 20:00
    // =====================================================
    const convertToInputTime = (time) => {
        if (!time) return "";

        // Already in HH:mm format
        if (/^\d{2}:\d{2}$/.test(time)) {
            return time;
        }

        const match = String(time)
            .trim()
            .match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);

        if (!match) return "";

        let hour = Number(match[1]);
        const minute = match[2];
        const period = match[3].toUpperCase();

        if (period === "PM" && hour !== 12) {
            hour += 12;
        }

        if (period === "AM" && hour === 12) {
            hour = 0;
        }

        return `${String(hour).padStart(2, "0")}:${minute}`;
    };

    // =====================================================
    // INPUT TIME => API TIME
    // 20:00 => 08:00 PM
    // =====================================================
    const convertToApiTime = (time) => {
        if (!time) return "";

        const [hourString, minute] = time.split(":");

        let hour = Number(hourString);

        const period = hour >= 12 ? "PM" : "AM";

        if (hour === 0) {
            hour = 12;
        } else if (hour > 12) {
            hour -= 12;
        }

        return `${String(hour).padStart(2, "0")}:${minute} ${period}`;
    };

    // =====================================================
    // LOAD CATEGORY
    // =====================================================
    useEffect(() => {
        const fetchCategories = async () => {
            setLoadingCategories(true);

            try {
                const res =
                    await EventCategoryServices.getActiveCategories();

                console.log("CATEGORY RESPONSE:", res);

                if (res?.status) {
                    setCategories(res?.data || []);
                } else {
                    setCategories([]);
                }
            } catch (error) {
                console.error("Category fetch error:", error);
                setCategories([]);
            } finally {
                setLoadingCategories(false);
            }
        };

        fetchCategories();
    }, []);

    // =====================================================
    // LOAD VENDORS
    // =====================================================
    useEffect(() => {
        const fetchVendors = async () => {
            setLoadingVendors(true);

            try {
                const res = await UserServices.getAllVendor();

                console.log("VENDOR RESPONSE:", res);

                if (res?.status) {
                    setVendors(res?.data || []);
                } else {
                    setVendors([]);
                }
            } catch (error) {
                console.error("Vendor fetch error:", error);
                setVendors([]);
            } finally {
                setLoadingVendors(false);
            }
        };

        fetchVendors();
    }, []);

    // =====================================================
    // LOAD STATES
    // =====================================================
    useEffect(() => {
        const fetchStates = async () => {
            setLoadingStates(true);

            try {
                const res = await UserServices.getState();

                console.log("STATE RESPONSE:", res);

                if (res?.status) {
                    setStates(res?.data || []);
                } else {
                    setStates([]);
                }
            } catch (error) {
                console.error("State fetch error:", error);
                setStates([]);
            } finally {
                setLoadingStates(false);
            }
        };

        fetchStates();
    }, []);

    // =====================================================
    // LOAD CITIES WHEN STATE CHANGES
    // =====================================================
    useEffect(() => {
        const fetchCities = async () => {
            if (!formValues.state) {
                setCities([]);
                return;
            }

            setLoadingCities(true);

            try {
                const res = await UserServices.getCities(
                    formValues.state
                );

                console.log("CITY RESPONSE:", res);

                if (res?.status) {
                    setCities(res?.data || []);
                } else {
                    setCities([]);
                }
            } catch (error) {
                console.error("City fetch error:", error);
                setCities([]);
            } finally {
                setLoadingCities(false);
            }
        };

        fetchCities();
    }, [formValues.state]);

    // =====================================================
    // LOAD EXISTING EVENT
    // =====================================================
    useEffect(() => {
        if (!user) return;

        console.log("EVENT EDIT DATA:", user);

        /*
         * Existing event API response se:
         *
         * categoryId
         * vendorId
         * eventName
         * eventDescription
         * eventDate
         * startTime
         * endTime
         * venue
         * address
         * city
         * totalCapacity
         * status
         * termsConditions
         * eventBanner
         *
         * populate kar rahe hain.
         */

        setFormValues({
            categoryId:
                user?.categoryId?._id ||
                user?.categoryId ||
                user?.category?._id ||
                user?.category ||
                "",

            vendorId:
                user?.vendorId?._id ||
                user?.vendorId ||
                user?.vendor?._id ||
                user?.vendor ||
                "",

            name: user?.eventName || "",

            description: user?.eventDescription || "",

            eventDate: user?.eventDate
                ? String(user.eventDate).substring(0, 10)
                : "",

            startTime: convertToInputTime(user?.startTime),

            endTime: convertToInputTime(user?.endTime),

            venue: user?.venue || "",

            address: user?.address || "",

            /*
             * API me state nahi aa raha.
             * State dropdown ko manually blank rakhenge.
             *
             * Agar event response me stateId/state milta hai
             * to usko use kar sakte ho.
             */
            state:
                user?.stateId?._id ||
                user?.stateId ||
                user?.state?._id ||
                user?.state ||
                "",

            stateName: user?.state?.name || "",

            city: user?.cityId?._id || user?.cityId || "",

            cityName:
                typeof user?.city === "object"
                    ? user?.city?.name || ""
                    : user?.city || "",

            totalCapacity:
                user?.totalCapacity !== undefined &&
                user?.totalCapacity !== null
                    ? String(user.totalCapacity)
                    : "",

            status: user?.status || "Active",

            termsConditions: user?.termsConditions || "",

            image: null,
        });

        // =================================================
        // EXISTING IMAGE
        // =================================================
        if (user?.eventBanner) {
            setPreviewImage(
                `${process.env.REACT_APP_URL}${user.eventBanner}`
            );
        } else if (user?.image) {
            setPreviewImage(
                `${process.env.REACT_APP_URL}${user.image}`
            );
        } else {
            setPreviewImage("img/placeholder-img.png");
        }
    }, [user]);

    // =====================================================
    // INPUT CHANGE
    // =====================================================
    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // =================================================
        // STATE
        // =================================================
        if (name === "state") {
            const selectedState = states.find(
                (state) => state._id === value
            );

            setFormValues((prev) => ({
                ...prev,

                state: value,

                stateName:
                    selectedState?.name || "",

                city: "",

                cityName: "",
            }));

            return;
        }

        // =================================================
        // CITY
        // =================================================
        if (name === "city") {
            const selectedCity = cities.find(
                (city) => city._id === value
            );

            setFormValues((prev) => ({
                ...prev,

                city: value,

                cityName:
                    selectedCity?.name || "",
            }));

            return;
        }

        // =================================================
        // CAPACITY
        // =================================================
        if (name === "totalCapacity") {
            const onlyNumber = value.replace(/\D/g, "");

            setFormValues((prev) => ({
                ...prev,

                totalCapacity: onlyNumber,
            }));

            return;
        }

        // =================================================
        // NORMAL INPUT
        // =================================================
        setFormValues((prev) => ({
            ...prev,

            [name]: value,
        }));
    };

    // =====================================================
    // IMAGE CHANGE
    // =====================================================
    const handleFileChange = (event) => {
        const file = event.target.files?.[0];

        if (!file) return;

        setPreviewImage(URL.createObjectURL(file));

        setFormValues((prev) => ({
            ...prev,

            image: file,
        }));
    };

    // =====================================================
    // SUBMIT UPDATE
    // =====================================================
    const handleSubmit = async (event) => {
        event.preventDefault();

        const eventId = user?._id || user?.id;

        if (!eventId) {
            alert("Event ID not found");
            return;
        }

        // =================================================
        // REQUIRED DROPDOWN VALIDATION
        // =================================================
        // if (!formValues.categoryId) {
        //     alert("Please select category");
        //     return;
        // }

        if (!formValues.vendorId) {
            alert("Please select vendor");
            return;
        }

        if (!formValues.cityName) {
            alert("Please select city");
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();

            // =================================================
            // CATEGORY
            // API FIELD = categoryId
            // =================================================
            formData.append(
                "categoryId",
                formValues.categoryId
            );

            // =================================================
            // VENDOR
            // API FIELD = vendorId
            // =================================================
            formData.append(
                "vendorId",
                formValues.vendorId
            );

            // =================================================
            // EVENT NAME
            // =================================================
            formData.append(
                "eventName",
                formValues.name
            );

            // =================================================
            // EVENT DESCRIPTION
            // =================================================
            formData.append(
                "eventDescription",
                formValues.description
            );

            // =================================================
            // EVENT DATE
            // =================================================
            formData.append(
                "eventDate",
                formValues.eventDate
            );

            // =================================================
            // START TIME
            // 20:00 => 08:00 PM
            // =================================================
            formData.append(
                "startTime",
                convertToApiTime(formValues.startTime)
            );

            // =================================================
            // END TIME
            // 23:59 => 11:59 PM
            // =================================================
            formData.append(
                "endTime",
                convertToApiTime(formValues.endTime)
            );

            // =================================================
            // VENUE
            // =================================================
            formData.append(
                "venue",
                formValues.venue
            );

            // =================================================
            // ADDRESS
            // =================================================
            formData.append(
                "address",
                formValues.address
            );

            // =================================================
            // CITY
            //
            // IMPORTANT:
            // API expects city NAME
            // not city ID
            // =================================================
            formData.append(
                "city",
                formValues.cityName
            );

            // =================================================
            // CAPACITY
            // =================================================
            formData.append(
                "totalCapacity",
                formValues.totalCapacity
            );

            // =================================================
            // STATUS
            // =================================================
            formData.append(
                "status",
                formValues.status
            );

            // =================================================
            // TERMS
            // =================================================
            formData.append(
                "termsConditions",
                formValues.termsConditions
            );

            // =================================================
            // IMAGE
            // Only send when new image selected
            // =================================================
            if (formValues.image) {
                formData.append(
                    "image",
                    formValues.image
                );
            }

            // =================================================
            // DEBUG PAYLOAD
            // =================================================
            console.log("UPDATE EVENT PAYLOAD:");

            for (const [key, value] of formData.entries()) {
                console.log(key, value);
            }

            // =================================================
            // API CALL
            // PUT /event/:id
            // =================================================
            const res =
                await EventServices.updateEvent(
                    eventId,
                    formData
                );

            console.log(
                "UPDATE EVENT RESPONSE:",
                res
            );

            if (res?.status) {
                alert(
                    res?.message ||
                    "Event updated successfully"
                );

                onSuccess?.();

                closeModal?.();
            } else {
                alert(
                    res?.message ||
                    "Failed to update event"
                );
            }
        } catch (error) {
            console.error(
                "Failed to update event:",
                error
            );

            alert(
                error?.response?.data?.message ||
                "Failed to update event"
            );
        } finally {
            setLoading(false);
        }
    };

    // =====================================================
    // UI
    // =====================================================
    return (
        <div
            className="modal fade edit-box show d-block"
            id="editModal"
            tabIndex={-1}
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">

                    {/* HEADER */}
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Event Edit
                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={closeModal}
                            aria-label="Close"
                        />
                    </div>

                    {/* BODY */}
                    <div className="modal-body">
                        <div className="container-box px-5">
                            <div className="container-box-inner table-reponsive-tabe">
                                <div className="page-details">

                                    <form onSubmit={handleSubmit}>

                                        <div className="row">

                                            {/* =================================================
                                                CATEGORY
                                            ================================================= */}
                                            {/* <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Category
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <select
                                                        name="categoryId"
                                                        className="form-control"
                                                        value={
                                                            formValues.categoryId
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        required
                                                    >
                                                        <option value="">
                                                            {loadingCategories
                                                                ? "Loading..."
                                                                : "Select Category"}
                                                        </option>

                                                        {categories.map(
                                                            (category) => (
                                                                <option
                                                                    key={
                                                                        category._id
                                                                    }
                                                                    value={
                                                                        category._id
                                                                    }
                                                                >
                                                                    {
                                                                        category.categoryName
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                    </select>

                                                </div>
                                            </div> */}

                                            {/* =================================================
                                                VENDOR
                                            ================================================= */}
                                          

                                            {/* =================================================
                                                EVENT NAME
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Event Name
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <input
                                                        type="text"
                                                        name="name"
                                                        className="form-control"
                                                        value={
                                                            formValues.name
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter event name"
                                                        required
                                                    />

                                                </div>
                                            </div>
  <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Vendor
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <select
                                                        name="vendorId"
                                                        className="form-control"
                                                        value={
                                                            formValues.vendorId
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        required
                                                    >
                                                        <option value="">
                                                            {loadingVendors
                                                                ? "Loading..."
                                                                : "Select Vendor"}
                                                        </option>

                                                        {vendors.map(
                                                            (vendor) => (
                                                                <option
                                                                    key={
                                                                        vendor._id
                                                                    }
                                                                    value={
                                                                        vendor._id
                                                                    }
                                                                >
                                                                    {
                                                                        vendor.name ||
                                                                        vendor.vendorName
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                    </select>

                                                </div>
                                            </div>
                                            {/* =================================================
                                                EVENT DATE
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Event Date
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <input
                                                        type="date"
                                                        name="eventDate"
                                                        className="form-control"
                                                        value={
                                                            formValues.eventDate
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        required
                                                    />

                                                </div>
                                            </div>

                                            {/* =================================================
                                                START TIME
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Start Time
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <input
                                                        type="time"
                                                        name="startTime"
                                                        className="form-control"
                                                        value={
                                                            formValues.startTime
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        required
                                                    />

                                                </div>
                                            </div>

                                            {/* =================================================
                                                END TIME
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        End Time
                                                    </label>

                                                    <input
                                                        type="time"
                                                        name="endTime"
                                                        className="form-control"
                                                        value={
                                                            formValues.endTime
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                    />

                                                </div>
                                            </div>

                                            {/* =================================================
                                                VENUE
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Venue
                                                    </label>

                                                    <input
                                                        type="text"
                                                        name="venue"
                                                        className="form-control"
                                                        value={
                                                            formValues.venue
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter venue"
                                                    />

                                                </div>
                                            </div>

                                            {/* =================================================
                                                TOTAL CAPACITY
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Total Capacity
                                                    </label>

                                                    <input
                                                        type="number"
                                                        name="totalCapacity"
                                                        className="form-control"
                                                        value={
                                                            formValues.totalCapacity
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter total capacity"
                                                    />

                                                </div>
                                            </div>

                                            {/* =================================================
                                                ADDRESS
                                            ================================================= */}
                                            <div className="col-lg-12 col-sm-12">
                                                <div className="input-field">

                                                    <label>
                                                        Address
                                                    </label>

                                                    <input
                                                        type="text"
                                                        name="address"
                                                        className="form-control"
                                                        value={
                                                            formValues.address
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter event address"
                                                    />

                                                </div>
                                            </div>

                                            {/* =================================================
                                                STATE
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        State
                                                    </label>

                                                    <select
                                                        name="state"
                                                        className="form-control"
                                                        value={
                                                            formValues.state
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                    >
                                                        <option value="">
                                                            {loadingStates
                                                                ? "Loading..."
                                                                : "Select State"}
                                                        </option>

                                                        {states.map(
                                                            (state) => (
                                                                <option
                                                                    key={
                                                                        state._id
                                                                    }
                                                                    value={
                                                                        state._id
                                                                    }
                                                                >
                                                                    {
                                                                        state.name
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                    </select>

                                                </div>
                                            </div>

                                            {/* =================================================
                                                CITY
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        City
                                                        <span className="red">
                                                            *
                                                        </span>
                                                    </label>

                                                    <select
                                                        name="city"
                                                        className="form-control"
                                                        value={
                                                            formValues.city
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        disabled={
                                                            !formValues.state ||
                                                            loadingCities
                                                        }
                                                        required
                                                    >
                                                        <option value="">
                                                            {loadingCities
                                                                ? "Loading..."
                                                                : "Select City"}
                                                        </option>

                                                        {cities.map(
                                                            (city) => (
                                                                <option
                                                                    key={
                                                                        city._id
                                                                    }
                                                                    value={
                                                                        city._id
                                                                    }
                                                                >
                                                                    {
                                                                        city.name
                                                                    }
                                                                </option>
                                                            )
                                                        )}
                                                    </select>

                                                </div>
                                            </div>

                                            {/* =================================================
                                                STATUS
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Status
                                                    </label>

                                                    <select
                                                        name="status"
                                                        className="form-control"
                                                        value={
                                                            formValues.status
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                    >
                                                        <option value="Active">
                                                            Active
                                                        </option>

                                                        <option value="Inactive">
                                                            Inactive
                                                        </option>
                                                    </select>

                                                </div>
                                            </div>

                                            {/* =================================================
                                                TERMS
                                            ================================================= */}
                                            <div className="col-lg-12 col-sm-12">
                                                <div className="input-field">

                                                    <label>
                                                        Terms & Conditions
                                                    </label>

                                                    <textarea
                                                        name="termsConditions"
                                                        className="form-control video-desc"
                                                        value={
                                                            formValues.termsConditions
                                                        }
                                                        onChange={
                                                            handleInputChange
                                                        }
                                                        placeholder="Enter terms and conditions"
                                                    />

                                                </div>
                                            </div>

                                            {/* =================================================
                                                IMAGE
                                            ================================================= */}
                                            <div className="col-lg-6 col-sm-6">
                                                <div className="input-field">

                                                    <label>
                                                        Event Image
                                                    </label>

                                                    <input
                                                        type="file"
                                                        name="image"
                                                        className="form-control"
                                                        accept="image/*"
                                                        onChange={
                                                            handleFileChange
                                                        }
                                                    />

                                                    <div className="file-preview text-center">

                                                        <img
                                                            src={
                                                                previewImage
                                                            }
                                                            alt="Event"
                                                            style={{
                                                                width: "120px",
                                                                height: "120px",
                                                                objectFit:
                                                                    "cover",
                                                                borderRadius:
                                                                    "8px",
                                                            }}
                                                        />

                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                        {/* =================================================
                                            SUBMIT
                                        ================================================= */}
                                        <button
                                            className="submit-green-btn"
                                            type="submit"
                                            disabled={loading}
                                        >
                                            {loading
                                                ? "Updating..."
                                                : "Submit"}
                                        </button>

                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default EventUpdate;

